import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

interface InputTextProps {
    label: string;
    placeholder?: string;
    error?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: () => void;
    name: string;
    type?: string;
    labelStyle?: string;
    inputStyle?: string;
}

const InputText = forwardRef<HTMLInputElement, InputTextProps>(
    (
        {
            label,
            name,
            placeholder = "",
            error,
            value = "",
            type = "text",
            onChange,
            onBlur,
            labelStyle,
            inputStyle
        },
        ref
    ) => {
        const [showPassword, setShowPassword] = useState(false);
        const id = `input-${name}`;

        const isPassword = type === "password";
        const inputType = isPassword && showPassword ? "text" : type;

        return (
            <div className="flex flex-col w-full items-start">
                <label htmlFor={id} className={`font-medium mb-[4px] ${labelStyle ? labelStyle : ""}`}>
                    {label}
                </label>

                <div className="relative w-full">
                    <input
                        ref={ref}
                        id={id}
                        name={name}
                        type={inputType}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        placeholder={placeholder}
                        className={`outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px] focus:border-[#3498db] focus:ring-1 focus:ring-[#3498db] transition-all duration-200 pr-10 ${inputStyle ? inputStyle : ""}`}
                    />

                    {isPassword && (
                        <button
                            type="button"
                            onClick={() => setShowPassword((prev) => !prev)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                        </button>
                    )}
                </div>

                <div className="h-[20px] mt-1">
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                </div>
            </div>
        );
    }
);

InputText.displayName = "InputText";

export default InputText;
